import { render } from "./practice_games_user_app.vue?vue&type=template&id=4ad835f1"
import script from "./practice_games_user_app.vue?vue&type=script&lang=js"
export * from "./practice_games_user_app.vue?vue&type=script&lang=js"

import exportComponent from "/home/sophia/sophia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__